// source: Protos/payments.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var google_protobuf_wrappers_pb = require('google-protobuf/google/protobuf/wrappers_pb.js');
goog.object.extend(proto, google_protobuf_wrappers_pb);
goog.exportSymbol('proto.wuxiaworld.api.v2.PaymentMethodGateway', null, global);
goog.exportSymbol('proto.wuxiaworld.api.v2.PaymentMethodItem', null, global);
goog.exportSymbol('proto.wuxiaworld.api.v2.PaymentMethodItem.CardDetails', null, global);
goog.exportSymbol('proto.wuxiaworld.api.v2.PaymentMethodType', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wuxiaworld.api.v2.PaymentMethodItem = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.wuxiaworld.api.v2.PaymentMethodItem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wuxiaworld.api.v2.PaymentMethodItem.displayName = 'proto.wuxiaworld.api.v2.PaymentMethodItem';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wuxiaworld.api.v2.PaymentMethodItem.CardDetails = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.wuxiaworld.api.v2.PaymentMethodItem.CardDetails, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wuxiaworld.api.v2.PaymentMethodItem.CardDetails.displayName = 'proto.wuxiaworld.api.v2.PaymentMethodItem.CardDetails';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wuxiaworld.api.v2.PaymentMethodItem.prototype.toObject = function(opt_includeInstance) {
  return proto.wuxiaworld.api.v2.PaymentMethodItem.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wuxiaworld.api.v2.PaymentMethodItem} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wuxiaworld.api.v2.PaymentMethodItem.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: (f = msg.getId()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    fullname: jspb.Message.getFieldWithDefault(msg, 2, ""),
    type: jspb.Message.getFieldWithDefault(msg, 3, 0),
    gateway: jspb.Message.getFieldWithDefault(msg, 4, 0),
    label: jspb.Message.getFieldWithDefault(msg, 5, ""),
    carddetails: (f = msg.getCarddetails()) && proto.wuxiaworld.api.v2.PaymentMethodItem.CardDetails.toObject(includeInstance, f),
    isdefault: jspb.Message.getBooleanFieldWithDefault(msg, 7, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wuxiaworld.api.v2.PaymentMethodItem}
 */
proto.wuxiaworld.api.v2.PaymentMethodItem.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wuxiaworld.api.v2.PaymentMethodItem;
  return proto.wuxiaworld.api.v2.PaymentMethodItem.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wuxiaworld.api.v2.PaymentMethodItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wuxiaworld.api.v2.PaymentMethodItem}
 */
proto.wuxiaworld.api.v2.PaymentMethodItem.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setFullname(value);
      break;
    case 3:
      var value = /** @type {!proto.wuxiaworld.api.v2.PaymentMethodType} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 4:
      var value = /** @type {!proto.wuxiaworld.api.v2.PaymentMethodGateway} */ (reader.readEnum());
      msg.setGateway(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setLabel(value);
      break;
    case 6:
      var value = new proto.wuxiaworld.api.v2.PaymentMethodItem.CardDetails;
      reader.readMessage(value,proto.wuxiaworld.api.v2.PaymentMethodItem.CardDetails.deserializeBinaryFromReader);
      msg.setCarddetails(value);
      break;
    case 7:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsdefault(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wuxiaworld.api.v2.PaymentMethodItem.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wuxiaworld.api.v2.PaymentMethodItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wuxiaworld.api.v2.PaymentMethodItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wuxiaworld.api.v2.PaymentMethodItem.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getFullname();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getGateway();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getLabel();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getCarddetails();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.wuxiaworld.api.v2.PaymentMethodItem.CardDetails.serializeBinaryToWriter
    );
  }
  f = message.getIsdefault();
  if (f) {
    writer.writeBool(
      7,
      f
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wuxiaworld.api.v2.PaymentMethodItem.CardDetails.prototype.toObject = function(opt_includeInstance) {
  return proto.wuxiaworld.api.v2.PaymentMethodItem.CardDetails.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wuxiaworld.api.v2.PaymentMethodItem.CardDetails} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wuxiaworld.api.v2.PaymentMethodItem.CardDetails.toObject = function(includeInstance, msg) {
  var f, obj = {
    brand: jspb.Message.getFieldWithDefault(msg, 1, ""),
    last4: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wuxiaworld.api.v2.PaymentMethodItem.CardDetails}
 */
proto.wuxiaworld.api.v2.PaymentMethodItem.CardDetails.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wuxiaworld.api.v2.PaymentMethodItem.CardDetails;
  return proto.wuxiaworld.api.v2.PaymentMethodItem.CardDetails.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wuxiaworld.api.v2.PaymentMethodItem.CardDetails} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wuxiaworld.api.v2.PaymentMethodItem.CardDetails}
 */
proto.wuxiaworld.api.v2.PaymentMethodItem.CardDetails.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setBrand(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setLast4(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wuxiaworld.api.v2.PaymentMethodItem.CardDetails.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wuxiaworld.api.v2.PaymentMethodItem.CardDetails.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wuxiaworld.api.v2.PaymentMethodItem.CardDetails} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wuxiaworld.api.v2.PaymentMethodItem.CardDetails.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBrand();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getLast4();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string brand = 1;
 * @return {string}
 */
proto.wuxiaworld.api.v2.PaymentMethodItem.CardDetails.prototype.getBrand = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.wuxiaworld.api.v2.PaymentMethodItem.CardDetails} returns this
 */
proto.wuxiaworld.api.v2.PaymentMethodItem.CardDetails.prototype.setBrand = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string last4 = 2;
 * @return {string}
 */
proto.wuxiaworld.api.v2.PaymentMethodItem.CardDetails.prototype.getLast4 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.wuxiaworld.api.v2.PaymentMethodItem.CardDetails} returns this
 */
proto.wuxiaworld.api.v2.PaymentMethodItem.CardDetails.prototype.setLast4 = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional google.protobuf.StringValue id = 1;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.wuxiaworld.api.v2.PaymentMethodItem.prototype.getId = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 1));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.wuxiaworld.api.v2.PaymentMethodItem} returns this
*/
proto.wuxiaworld.api.v2.PaymentMethodItem.prototype.setId = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.wuxiaworld.api.v2.PaymentMethodItem} returns this
 */
proto.wuxiaworld.api.v2.PaymentMethodItem.prototype.clearId = function() {
  return this.setId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.wuxiaworld.api.v2.PaymentMethodItem.prototype.hasId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string fullName = 2;
 * @return {string}
 */
proto.wuxiaworld.api.v2.PaymentMethodItem.prototype.getFullname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.wuxiaworld.api.v2.PaymentMethodItem} returns this
 */
proto.wuxiaworld.api.v2.PaymentMethodItem.prototype.setFullname = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional PaymentMethodType type = 3;
 * @return {!proto.wuxiaworld.api.v2.PaymentMethodType}
 */
proto.wuxiaworld.api.v2.PaymentMethodItem.prototype.getType = function() {
  return /** @type {!proto.wuxiaworld.api.v2.PaymentMethodType} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.wuxiaworld.api.v2.PaymentMethodType} value
 * @return {!proto.wuxiaworld.api.v2.PaymentMethodItem} returns this
 */
proto.wuxiaworld.api.v2.PaymentMethodItem.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional PaymentMethodGateway gateway = 4;
 * @return {!proto.wuxiaworld.api.v2.PaymentMethodGateway}
 */
proto.wuxiaworld.api.v2.PaymentMethodItem.prototype.getGateway = function() {
  return /** @type {!proto.wuxiaworld.api.v2.PaymentMethodGateway} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.wuxiaworld.api.v2.PaymentMethodGateway} value
 * @return {!proto.wuxiaworld.api.v2.PaymentMethodItem} returns this
 */
proto.wuxiaworld.api.v2.PaymentMethodItem.prototype.setGateway = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional string label = 5;
 * @return {string}
 */
proto.wuxiaworld.api.v2.PaymentMethodItem.prototype.getLabel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.wuxiaworld.api.v2.PaymentMethodItem} returns this
 */
proto.wuxiaworld.api.v2.PaymentMethodItem.prototype.setLabel = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional CardDetails cardDetails = 6;
 * @return {?proto.wuxiaworld.api.v2.PaymentMethodItem.CardDetails}
 */
proto.wuxiaworld.api.v2.PaymentMethodItem.prototype.getCarddetails = function() {
  return /** @type{?proto.wuxiaworld.api.v2.PaymentMethodItem.CardDetails} */ (
    jspb.Message.getWrapperField(this, proto.wuxiaworld.api.v2.PaymentMethodItem.CardDetails, 6));
};


/**
 * @param {?proto.wuxiaworld.api.v2.PaymentMethodItem.CardDetails|undefined} value
 * @return {!proto.wuxiaworld.api.v2.PaymentMethodItem} returns this
*/
proto.wuxiaworld.api.v2.PaymentMethodItem.prototype.setCarddetails = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.wuxiaworld.api.v2.PaymentMethodItem} returns this
 */
proto.wuxiaworld.api.v2.PaymentMethodItem.prototype.clearCarddetails = function() {
  return this.setCarddetails(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.wuxiaworld.api.v2.PaymentMethodItem.prototype.hasCarddetails = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional bool isDefault = 7;
 * @return {boolean}
 */
proto.wuxiaworld.api.v2.PaymentMethodItem.prototype.getIsdefault = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 7, false));
};


/**
 * @param {boolean} value
 * @return {!proto.wuxiaworld.api.v2.PaymentMethodItem} returns this
 */
proto.wuxiaworld.api.v2.PaymentMethodItem.prototype.setIsdefault = function(value) {
  return jspb.Message.setProto3BooleanField(this, 7, value);
};


/**
 * @enum {number}
 */
proto.wuxiaworld.api.v2.PaymentMethodType = {
  UNKNOWN: 0,
  CARD: 1,
  PAYPAL: 2
};

/**
 * @enum {number}
 */
proto.wuxiaworld.api.v2.PaymentMethodGateway = {
  NONE: 0,
  STRIPE: 1,
  BRAINTREE: 2,
  APPLE: 3,
  GOOGLEPLAY: 4,
  STRIPECHECKOUT: 5
};

goog.object.extend(exports, proto.wuxiaworld.api.v2);
